module.exports = __webpack_public_path__ + "static/img/til140.1197586.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/til140.png
// module id = 8XOO
// module chunks = 1